
export const prefs = {

    PREF_DEBUG: "cr_showDebug",
    PREF_TAGS: "cr_tags",

    


    getPref: (key, defaultValue = null) => {
        let value = localStorage.getItem(key)
        if (value !== null) {
            return JSON.parse(value)
        } else {
            return defaultValue
        }
    },

    setPref: (key, value) => {
        localStorage.setItem(key, value)
    },

    clear: (keys = []) => {
        keys.forEach((k) => {
            localStorage.removeItem(k)
        })
    }
}